var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 15.75H12.25C10.8499 15.75 10.1498 15.75 9.61502 15.4775C9.14462 15.2378 8.76217 14.8554 8.52248 14.385C8.25 13.8502 8.25 13.1501 8.25 11.75V6.41667C8.25 5.01654 8.25 4.31647 8.52248 3.78169C8.76217 3.31129 9.14462 2.92883 9.61502 2.68915C10.1498 2.41667 10.8499 2.41667 12.25 2.41667H12.4167M12.4167 15.75C12.4167 16.6705 13.1629 17.4167 14.0833 17.4167C15.0038 17.4167 15.75 16.6705 15.75 15.75C15.75 14.8295 15.0038 14.0833 14.0833 14.0833C13.1629 14.0833 12.4167 14.8295 12.4167 15.75ZM12.4167 2.41667C12.4167 3.33714 13.1629 4.08333 14.0833 4.08333C15.0038 4.08333 15.75 3.33714 15.75 2.41667C15.75 1.49619 15.0038 0.75 14.0833 0.75C13.1629 0.75 12.4167 1.49619 12.4167 2.41667ZM4.08333 9.08333L12.4167 9.08333M4.08333 9.08333C4.08333 10.0038 3.33714 10.75 2.41667 10.75C1.49619 10.75 0.75 10.0038 0.75 9.08333C0.75 8.16286 1.49619 7.41667 2.41667 7.41667C3.33714 7.41667 4.08333 8.16286 4.08333 9.08333ZM12.4167 9.08333C12.4167 10.0038 13.1629 10.75 14.0833 10.75C15.0038 10.75 15.75 10.0038 15.75 9.08333C15.75 8.16286 15.0038 7.41667 14.0833 7.41667C13.1629 7.41667 12.4167 8.16286 12.4167 9.08333Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchIcon);
export default __webpack_public_path__ + "static/media/branch-icon.bffdcaabcc1bb97cd2944b83d17ea0fa.svg";
export { ForwardRef as ReactComponent };